import React, { useState } from 'react';
import { Box } from '@mui/material';
import { TopicList } from '../components/TopicList';
import { TopicForm } from '../components/TopicForm';
import type { Category } from '../types';
import { useSnackbar } from '../hooks/useSnackbar';
import { ToastNotification } from '../components/ToastNotification';

export const ResourceTopicManagementPage: React.FC = () => {
  const [topicFormOpen, setTopicFormOpen] = useState(false);
  const [selectedTopic, setSelectedTopic] = useState<Category | null>(null);
  const [isEditing, setIsEditing] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const { snackbar, showSuccess, showError, hideSnackbar } = useSnackbar();

  const handleAddTopic = () => {
    setSelectedTopic(null);
    setIsEditing(false);
    setTopicFormOpen(true);
  };

  const handleEditTopic = (topic: Category) => {
    setSelectedTopic(topic);
    setIsEditing(true);
    setTopicFormOpen(true);
  };

  const handleTopicSaved = (topic: Category) => {
    const wasEditing = isEditing;
    setTopicFormOpen(false);
    setSelectedTopic(null);
    setIsEditing(false);
    setRefreshTrigger(prev => prev + 1);
    showSuccess(wasEditing ? 'Cập nhật chủ đề thành công!' : 'Thêm chủ đề thành công!');
  };

  const handleTopicSaveError = (error: string) => {
    showError(error);
  };

  return (
    <Box sx={{ p: 3 }}>
      <TopicList
        onEdit={handleEditTopic}
        onAdd={handleAddTopic}
        refreshTrigger={refreshTrigger}
      />

      <TopicForm
        open={topicFormOpen}
        onClose={() => {
          setTopicFormOpen(false);
          setSelectedTopic(null);
          setIsEditing(false);
        }}
        onSave={handleTopicSaved}
        onError={handleTopicSaveError}
        topic={selectedTopic}
        title={isEditing ? 'Chỉnh sửa chủ đề' : 'Thêm chủ đề mới'}
      />

      <ToastNotification
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={hideSnackbar}
      />
    </Box>
  );
};

